import React, { useState, useEffect, useCallback } from "react";
import { Blinds } from "lucide-react";
import { apiGet } from "@/lib/api";
import ProfileObloaneSection from "./ProfileObloaneSection";

const SUBSECTIUNI = [
  { id: "profile", nume: "Profile", ready: true },
  { id: "feronerie_tipuri", nume: "Feronerie Tipuri", ready: false },
  { id: "feronerie_seturi", nume: "Feronerie Seturi", ready: false },
  { id: "lamele", nume: "Lamele", ready: false },
  { id: "lemn", nume: "Lemn", ready: false },
  { id: "dimensiuni", nume: "Dimensiuni", ready: false },
];

export default function ConfigurareObloanePage() {
  const [active, setActive] = useState("profile");
  const [stats, setStats] = useState({});

  const fetchStats = useCallback(async () => {
    try {
      const data = await apiGet("/obloane-config/stats");
      setStats(data || {});
    } catch {
      /* silentios */
    }
  }, []);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  return (
    <div data-testid="configurare-obloane-page">
      <div className="mb-5">
        <div className="flex items-center gap-2 mb-4">
          <Blinds className="h-6 w-6 text-amber-600" />
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight">Configurare Obloane</h1>
        </div>
        <div className="flex flex-wrap gap-2">
          {SUBSECTIUNI.map((sub) => {
            const isActive = active === sub.id;
            const count = stats[sub.id] || 0;
            return (
              <button
                key={sub.id}
                data-testid={`oblon-cfg-tab-${sub.id}`}
                onClick={() => setActive(sub.id)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm whitespace-nowrap transition-colors ${
                  isActive ? "bg-amber-100 text-amber-800 font-medium" : "text-slate-600 hover:bg-slate-100"
                }`}
              >
                <span className={`w-2 h-2 rounded-full ${isActive ? "bg-amber-600" : "bg-amber-400"}`} />
                {sub.nume}
                {count > 0 && <span className="text-xs bg-slate-200 px-1.5 py-0.5 rounded-full">{count}</span>}
                {!sub.ready && <span className="text-[10px] text-slate-400 uppercase tracking-wide">soon</span>}
              </button>
            );
          })}
        </div>
      </div>

      {active === "profile" && <ProfileObloaneSection onStatsChange={fetchStats} />}
      {active !== "profile" && (
        <div className="py-16 text-center text-slate-400" data-testid="oblon-cfg-placeholder">
          Modulul se aduce intr-un batch urmator.
        </div>
      )}
    </div>
  );
}
